// SamostoyatelnayaRegistratsiyaTantsoraFederatsii
import React, { useState, useEffect } from 'react';
import { Form, Input, List } from 'antd';

import { errorCatch, QueryDetail, QueryOrder, QueryParam, READWITH, useAuth } from 'fennec-ui';

import VirtualList from 'rc-virtual-list';
import Icofont from 'react-icofont';
var _ = require('lodash');

const { Search } = Input;

function ShkolaListSelector(props) {
    const { value, onChange } = props;
    const auth = useAuth();
    const ContainerHeight = 400;
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState();
    const [data, setData] = useState([]);
    const [page, setPage] = useState();
    const appendData = (page) => {
        if (!page.total || (page.total && page.current <= page.total)) {
            setLoading(true);
            READWITH(auth, "ShkoliFederatsii", [
                QueryDetail("model"),
                QueryOrder("nazvanieShkoliTantsev", "ASC"),
                QueryParam("w-nnu-DokumentRegistratsii", 0),
                QueryParam("w-nu-DokumentVikhodaIzFederatsii", 0),
                (page.quick && page.quick.length <= 6) ? QueryParam("w-co-nazvanieShkoliTantsev", page.quick) : undefined,
                (page.quick && page.quick.length > 6) ? QueryParam("w-sim-nazvanieShkoliTantsev", page.quick) : undefined,
                QueryParam("page", page.current),
                // QueryParam("count", 6),
            ], ({ data }) => {
                if (page.current <= 1) {
                    setData(data?.content);
                } else {
                    setData(o => [...o, ...data.content]);
                }
                setPage(o => ({ current: page.current, quick: page.quick, total: data.totalPages }));
                setLoading(false);
            }, (err) => errorCatch(err, () => setLoading(false)));
        }
    };
    useEffect(()=>{
        if(selected){
            onChange(selected);
        }
    },[selected])
    useEffect(()=>{
        if(value){
            setSelected(value);
        }
    },[value])
    useEffect(() => {
        appendData({ current: 1, quick: "", total: undefined });
    }, []);

    const _onSearch = (v) => {
        appendData({ current: 1, quick: v, total: undefined });
    };
    const onSearch = React.useCallback(_.throttle(_onSearch, 3000, { trailing: true }),[]);

    const onScroll = React.useCallback((e) => {
        if (e.currentTarget.scrollHeight - e.currentTarget.scrollTop === ContainerHeight) {
            appendData({ ...page, current: page.current + 1 });
        }
    },[page]);
    return (<div>
        <div style={{ paddingBottom: "25px" }}>
            <Search
                // value={quick}
                enterButton={<Icofont icon="search" />}
                // suffix={suffix}
                onSearch={_onSearch}
                onChange={(e) => onSearch(e.target.value)}
            />
        </div>
        <List loading={loading}>
            <VirtualList
                data={data}
                height={ContainerHeight}
                itemHeight={47}
                itemKey="ID"
                onScroll={onScroll}
            >
                {(item) => (
                    <List.Item key={item.ID} style={{ cursor: "pointer", padding: "12px 10px", borderRadius: "4px", backgroundColor: (selected === item.ID) ? "#d7f4ff" : "transparent" }} onClick={() => setSelected(item.ID)}>
                        <List.Item.Meta
                            // avatar={<Avatar src={item.picture.large} />}
                            title={<span>{item.nazvanieShkoliTantsev}</span>}
                            description={item.regionalnoeOtdelenie.nazvanie}
                        />
                        {/* <div>Content</div> */}
                    </List.Item>
                )}
            </VirtualList>
        </List>
    </div>)
}

export default function RegistratsiyaTantsoraShkoli(props) {
    const { auth } = props;

    return (
        <div>
            <Form
                form={props.form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                }}
            >
                <Form.Item
                    name={"shkolaID"}
                    // label={"Школы федерации"}
                    rules={[{ required: true, message: 'Выберите школу!' }]}
                >
                    <ShkolaListSelector />
                </Form.Item>

            </Form>
        </div>
    );
}
